import { z } from "zod";

const PermissionSchema = z.object({
    id: z.number(),
    name: z.string(),
    display_name: z.nullable(z.string()),
    group: z.nullable(z.string()),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    pivot: z.object({
        role_id: z.number(),
        permission_id: z.number()
    })
})

const UserSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    email_verified_at: z.nullable(z.string()),
    created_at: z.string(),
    updated_at: z.string(),
    channex_user_api_key: z.nullable(z.string()),
    username: z.nullable(z.string()),
    phone: z.nullable(z.string()),
    pivot: z.object({
        model_type: z.string(),
        role_id: z.number(),
        model_id: z.string()
    })
})

const RoleSchema = z.object({
    id: z.number(),
    name: z.string(),
    property_id: z.nullable(z.string()),
    display_name: z.string(),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    permissions: z.array(PermissionSchema),
    users: z.array(UserSchema)
})

export const RoleResponse = z.object({
    code: z.number(),
    success: z.boolean(),
    message: z.string(),
    data: RoleSchema
});